// utils/ratings.js

/**
 * Calculate the average star rating from an array of reviews.
 * Only considers reviews with stars > 0.
 * Returns a number rounded to 1 decimal place.
 * @param {Array} reviews - Array of review objects: { stars: number, recommended: boolean }
 * @returns {number} average rating
 */
export function getAverageRating(reviews = []) {
  // Only consider reviews with stars greater than 0
  const validReviews = reviews.filter(r => r.stars > 0);

  if (validReviews.length === 0) return 0;

  const totalStars = validReviews.reduce((sum, r) => sum + r.stars, 0);
  return Math.round((totalStars / validReviews.length) * 10) / 10;
}

/**
 * Calculate the recommendation percentage from an array of reviews.
 * Only considers reviews with stars > 0.
 * Returns an integer percentage (0-100).
 * @param {Array} reviews - Array of review objects: { stars: number, recommended: boolean }
 * @returns {number} recommendation rate in %
 */
export function getRecommendationRate(reviews = []) {
  const validReviews = reviews.filter(r => r.stars > 0);

  if (validReviews.length === 0) return 0;

  const recommendedCount = validReviews.filter(r => r.recommended).length;
  return Math.round((recommendedCount / validReviews.length) * 100);
}
